import { SET_FILTER_OPTIONS, SET_USER_FILTER } from "./types";

export const setFilterOptions = (data) => ({
  type: SET_FILTER_OPTIONS,
  data: data,
});

export const setUserFilter = (data) => ({
  type: SET_USER_FILTER,
  data: data,
});
